import React from 'react';
import SortableItem from '../../common/DnD/SortableItem';
import PresetDndContext from '../../common/DnD/PresetDndContext';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { dragSort } from '../../../helpers/sorters';

const ExportFieldSortable = ({
  selectedFields,
  setSelectedFields,
  removeField,
  clearSavedExport,
}) => {
  const handleDragEnd = (e) => {
    const { active, over } = e;
    if (over && active.id !== over.id) {
      setSelectedFields((fields) => dragSort(fields, active, over));
      clearSavedExport();
    }
  };

  return (
    <PresetDndContext handleDragEnd={handleDragEnd}>
      {selectedFields.length > 0 && (
        <ol className='orderable export-field-list'>
          <SortableContext
            strategy={verticalListSortingStrategy}
            items={selectedFields}
          >
            {selectedFields.map((f) => {
              return (
                <SortableItem key={f.id + '-export'} id={f.id}>
                  {f.name}
                  <a onClick={() => removeField(f.id)}>&times;</a>
                </SortableItem>
              );
            })}
          </SortableContext>
        </ol>
      )}
    </PresetDndContext>
  );
};

export default ExportFieldSortable;
